import { Link, useParams } from "react-router";
import { Alerta, Button, Spinner, Stack } from "@/components";
import { DetalleCuenta } from "./DetalleCuenta";
import { useCuentaTab } from "./useCuentaTab";

/** `key={id}` fuerza un remount al cambiar de fiduciante (mismo criterio que LlamadoTab). */
export function CuentaTab() {
  const { id } = useParams();
  return <Ficha key={id} id={Number(id)} />;
}

function Ficha({ id }: { id: number }) {
  const t = useCuentaTab(id);
  return (
    <Stack espacio={6}>
      <Link to="/cuentas-corrientes" className="text-chico text-primario">
        ← Cuentas corrientes
      </Link>
      {t.cargando && (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      )}
      {t.noExiste && <p className="rounded-control bg-superficie-2 px-3 py-2">Ese fiduciante no es de este fideicomiso.</p>}
      {t.errorCarga && (
        <Stack espacio={3}>
          <Alerta texto={t.errorCarga} />
          <div>
            <Button variante="secundario" onClick={t.reintentar}>Reintentar</Button>
          </div>
        </Stack>
      )}
      {t.cuenta && (
        <>
          <h1 className="text-pantalla font-light tracking-[-0.03em]">{t.cuenta.nombre}</h1>
          <DetalleCuenta cuenta={t.cuenta} />
        </>
      )}
    </Stack>
  );
}
